import {
  DELETE_NOT_ACTIVE_SURVEYS_FAIL,
  DELETE_NOT_ACTIVE_SURVEYS_SUCCESS,
  GET_NOT_ACTIVE_SURVEYS,
  GET_NOT_ACTIVE_SURVEYS_FAIL,
  GET_NOT_ACTIVE_SURVEYS_SUCCESS,
  INIT_DELETE_NOT_ACTIVE_SURVEYS,
  SET_SELECTED_SURVEYS,
  RESET_DELETE_STATUS,
  ADD_SURVEYS_ERROR,
  ADD_SURVEYS_START,
  ADD_SURVEYS_SUCCESS,
  DELETE_SURVEY_REQUEST_ERROR,
  DELETE_SURVEY_REQUEST_START,
  DELETE_SURVEY_REQUEST_SUCCESS,
  GET_AUDIT_TRAIL_ERROR,
  GET_AUDIT_TRAIL_START,
  GET_AUDIT_TRAIL_SUCCESS,
  GET_PENDING_SURVEYS_ERROR,
  GET_PENDING_SURVEYS_START,
  GET_PENDING_SURVEYS_SUCCESS,
  GET_PUBLISHERS_ERROR,
  GET_PUBLISHERS_START,
  GET_PUBLISHERS_SUCCESS,
  RESET_ADD_SURVEYS_ERROR,
  RESET_DELETE_SURVEY_ERROR,
  SET_NEW_SURVEY_NAME,
  SET_OFFSET,
  SET_SELECTED_PUBLISHER,
  SLC_AUDIT_TRAIL_LIMIT,
  UPDATE_PENDING_SURVEY
} from './SurveyLibraryChangeActions';

const initialState = {
  auditTrails: [],
  getAuditTrailError: false,
  getAuditTrailLoading: false,
  limit: SLC_AUDIT_TRAIL_LIMIT,
  pendingSurveyRequests: [],
  offset: 0,
  totalCount: 0,
  loadingNotActiveSurveys: false,
  loadedNotActiveSurveys: false,
  notActiveSurveys: [],
  notActiveSelectedSurveys: [],
  error: null,
  isDeleting: false,
  isDeleted: false,
  isRetrievingPendingSurveys: false,
  isRetrievingPendingSurveysError: false,
  isDeletingSurveyRequest: false,
  hasDeleteSurveyRequestError: false,
  isRetrievingPublishers: false,
  isRetrievingPublishersError: false,
  publishers: [],
  selectedPublisher: null,
  newSurveyName: null,
  isAddingSurveys: false,
  hasAddSurveysError: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_AUDIT_TRAIL_START: {
      return {
        ...state,
        getAuditTrailLoading: true
      };
    }
    case GET_AUDIT_TRAIL_SUCCESS: {
      return {
        ...state,
        getAuditTrailError: false,
        getAuditTrailLoading: false,
        auditTrails: action.auditTrails,
        totalCount: action.totalCount
      };
    }
    case GET_AUDIT_TRAIL_ERROR: {
      return {
        ...state,
        getAuditTrailError: true,
        getAuditTrailLoading: false,
        totalCount: 0
      };
    }
    case SET_OFFSET: {
      return {
        ...state,
        offset: action.offset
      };
    }
    case GET_NOT_ACTIVE_SURVEYS: {
      return {
        ...state,
        loadingNotActiveSurveys: true
      };
    }
    case GET_NOT_ACTIVE_SURVEYS_SUCCESS: {
      return {
        ...state,
        loadingNotActiveSurveys: false,
        loadedNotActiveSurveys: true,
        notActiveSurveys: action.result.data.surveys
      };
    }
    case GET_NOT_ACTIVE_SURVEYS_FAIL: {
      return {
        ...state,
        loadingNotActiveSurveys: false,
        loadedNotActiveSurveys: true,
        error: action.error
      };
    }
    case SET_SELECTED_SURVEYS: {
      return {
        ...state,
        notActiveSelectedSurveys: action.surveys
      };
    }
    case INIT_DELETE_NOT_ACTIVE_SURVEYS: {
      return {
        ...state,
        isDeleting: true
      };
    }
    case DELETE_NOT_ACTIVE_SURVEYS_SUCCESS: {
      return {
        ...state,
        isDeleting: false,
        isDeleted: true
      };
    }
    case RESET_DELETE_STATUS: {
      return {
        ...state,
        isDeleting: false,
        isDeleted: false
      };
    }
    case DELETE_NOT_ACTIVE_SURVEYS_FAIL: {
      return {
        ...state,
        isDeleting: false,
        isDeleted: false,
        error: action.error
      };
    }
    case GET_PENDING_SURVEYS_START: {
      return {
        ...state,
        isRetrievingPendingSurveys: true
      };
    }
    case GET_PENDING_SURVEYS_SUCCESS: {
      return {
        ...state,
        isRetrievingPendingSurveys: false,
        isRetrievingPendingSurveysError: false,
        pendingSurveyRequests: action.surveys
      };
    }
    case GET_PENDING_SURVEYS_ERROR: {
      return {
        ...state,
        isRetrievingPendingSurveys: false,
        isRetrievingPendingSurveysError: true
      };
    }
    case DELETE_SURVEY_REQUEST_START: {
      return {
        ...state,
        isDeletingSurveyRequest: true
      };
    }
    case DELETE_SURVEY_REQUEST_SUCCESS: {
      return {
        ...state,
        isDeletingSurveyRequest: false,
        hasDeleteSurveyRequestError: false
      };
    }
    case DELETE_SURVEY_REQUEST_ERROR: {
      return {
        ...state,
        isDeletingSurveyRequest: false,
        hasDeleteSurveyRequestError: true
      };
    }
    case GET_PUBLISHERS_START: {
      return {
        ...state,
        isRetrievingPublishers: true
      };
    }
    case GET_PUBLISHERS_SUCCESS: {
      return {
        ...state,
        isRetrievingPublishers: false,
        isRetrievingPublishersError: false,
        publishers: action.publishers
      };
    }
    case GET_PUBLISHERS_ERROR: {
      return {
        ...state,
        isRetrievingPublishers: false,
        isRetrievingPublishersError: true
      };
    }
    case SET_SELECTED_PUBLISHER: {
      return {
        ...state,
        selectedPublisher: action.publisher
      };
    }
    case SET_NEW_SURVEY_NAME: {
      return {
        ...state,
        newSurveyName: action.surveyName
      };
    }
    case ADD_SURVEYS_START: {
      return {
        ...state,
        isAddingSurveys: true
      };
    }
    case ADD_SURVEYS_SUCCESS: {
      return {
        ...state,
        isAddingSurveys: false,
        hasAddSurveysError: false
      };
    }
    case ADD_SURVEYS_ERROR: {
      return {
        ...state,
        isAddingSurveys: false,
        hasAddSurveysError: true
      };
    }
    case UPDATE_PENDING_SURVEY: {
      const pendingSurveyRequests = [...state.pendingSurveyRequests];
      const index = pendingSurveyRequests.findIndex(survey => survey.requestId === action.survey.requestId);
      pendingSurveyRequests.splice(index, 1, action.survey);
      return {
        ...state,
        pendingSurveyRequests
      };
    }
    case RESET_ADD_SURVEYS_ERROR: {
      return {
        ...state,
        hasAddSurveysError: false
      };
    }
    case RESET_DELETE_SURVEY_ERROR: {
      return {
        ...state,
        hasDeleteSurveyRequestError: false
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
